import Icon from '../components/Icon.vue'

Icon.register({"bookmark":{"width":384,"height":512,"paths":[{"d":"M0 512V48C0 21.5 21.5 0 48 0H336C362.5 0 384 21.5 384 48V512L192 400 0 512z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bookmark.js
// module id = xHhM
// module chunks = 0